import React, { useEffect } from "react";
import CustomTable from "../../Base/views/CustomTable";
import {
  Box,
  Button,
  FormControl,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ConvertDateTime } from "../../Base/helper/baseFunctions";
import { getWorkspaceExpiryRequestAction } from "../../../../store/MeeplAdmin/Workspace/Action";
import SelectableSearch from "../../Base/views/SelectableSearch";
import { PlansAction } from "../../../../store/Plans/Action";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import Popup from "../../Base/views/Popup";
import CommonDatePicker from "../../Base/views/CommonDatePicker";
import UpdateIcon from "@mui/icons-material/Update";
import { updateWorkspaceExpiryRequestHelper } from "../helper/WorkspaceHelper";

const ExpiryWorkspace = ({ value, setworkspaceManage, countryCode }) => {
  const enable_initialValues = {
    expiry_date: "",
    planid: "",
  };
  const dispatch = useDispatch();
  const theme = useTheme();
  const { ExtendWorkspaceRequestdata, Loading } = useSelector(
    (state) => state?.MeeplAdminReducer?.WorkspaceReducer
  );
  const [enable, setEnable] = useState(false);
  const { plansdata } = useSelector((state) => state?.PlansReducer);
  const [plansData, setplansData] = useState({ load: true, values: [] });
  const [enableData, setEnableData] = useState(enable_initialValues);
  const [currentData, setCurrentData] = useState({});

  useEffect(() => {
    if (value === "3") {
      dispatch(getWorkspaceExpiryRequestAction({ pre_req: "true", country_code: countryCode }));
    } else {
      dispatch(getWorkspaceExpiryRequestAction({ pre_req: "false", country_code: countryCode }));
    }
    dispatch(PlansAction());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    currentData !== null &&
      setEnableData({
        ...currentData,
        planid: currentData?.planid
          ? {
              planid: currentData?.planid,
              planname: currentData?.planname,
            }
          : "",
      });
    // eslint-disable-next-line
  }, [currentData]);

  const handleEnableChange = (event, value) => {
    if (["planid"].includes(event)) {
      if (value) {
        setEnableData({ ...enableData, [event]: value });
      } else {
        setEnableData({ ...enableData, [event]: "" });
      }
    } else {
      setEnableData({ ...enableData, [event.target.name]: event.target.value });
    }
  };

  const handleEnableWorkspace = () => {
    if (currentData?.company_id) {
      if (value === "3") {
        updateWorkspaceExpiryRequestHelper({
          ...enableData,
          pre_req: true,
        })
          .then((res) => {
            dispatch(getWorkspaceExpiryRequestAction({ pre_req: "true", country_code: countryCode }));
          })
          .catch((err) => {});
      } else {
        updateWorkspaceExpiryRequestHelper({
          ...enableData,
          pre_req: false,
        })
          .then((res) => {
            dispatch(getWorkspaceExpiryRequestAction({ pre_req: "false", country_code: countryCode }));
          })
          .catch((err) => {});
      }

      setEnable(false);
      setCurrentData([]);
      setEnableData(enable_initialValues);
    }
  };

  const handleEnableclose = () => {
    setEnable(false);
    setCurrentData([]);
    setEnableData(enable_initialValues);
  };


    return (
      <>
        <Box sx={{ margin: "0px 16px", boxShadow: "0px 2px 4px -1px rgba(158, 158, 158, 0.2), 0px 4px 5px 0px rgba(158, 158, 158, 0.14), 0px 1px 10px 0px rgba(158, 158, 158, 0.12)" }}>
          <CustomTable
            data={ExtendWorkspaceRequestdata}
            loading={Loading}
            columns={[
              { label: "Company Name", field: "company_full_name", render: (rowData) => (
                <Box>
                  <Typography variant="body2" sx={{ fontWeight: 500, fontSize: "13px" }}>
                    {rowData.company_full_name}
                  </Typography>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "11px" }}>
                    {rowData.email_id}
                  </Typography>
                </Box>
              ) },
              { label: "Workspace Info", field: "domainname", render: (rowData) => (
                <Box>
                  <Typography variant="body2" sx={{ fontWeight: 500, fontSize: "13px" }}>
                    {rowData.domainname}
                  </Typography>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "11px" }}>
                    Created: {rowData.createdon ? ConvertDateTime(rowData.createdon) : "N/A"}
                  </Typography>
                </Box>
              ) },
              { label: "Team Size", field: "team_size", render: (rowData) => (
                <Typography variant="body2" sx={{ fontWeight: 500, fontSize: "13px" }}>
                  {rowData?.team_size || 0}
                </Typography>
              ) },
              { label: "Plan & Expiry", field: "planname", render: (rowData) => (
                <Box>
                  <Typography variant="body2" sx={{ fontWeight: 500, fontSize: "13px" }}>
                    {rowData.planname}
                  </Typography>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "11px" }}>
                    Expires: {rowData.expiry_date ? ConvertDateTime(rowData.expiry_date) : "N/A"}
                  </Typography>
                </Box>
              ) },
            ]}
            totalCount={ExtendWorkspaceRequestdata?.length || 0}
            // Add actions and other props as needed for consistency
          />
        </Box>

      <Popup
        maxWidth="sm"
        title="Extend Expiry Date"
        isMasterProduct={true}
        setOpenPopup={handleEnableclose}
        openPopup={enable}
        fullWidth={true}
      >
        <Box>
          <FormControl fullWidth>
            <CommonDatePicker
              size="small"
              name="expiry_date"
              label="Expiry Date"
              pickerType="date"
              onKeyPress={(e) => e.preventDefault()}
              onKeyDown={(e) => e.preventDefault()}
              pickerFormat="dd/MM/yyyy"
              DefaultDTvalue={enableData?.expiry_date}
              required
              minDate={new Date()}
              handleChange={(value) =>
                handleEnableChange({
                  target: {
                    name: "expiry_date",
                    value: value
                      ? `${
                          value?.getFullYear() +
                          "-" +
                          ("0" + (value?.getMonth() + 1)).slice(-2) +
                          "-" +
                          ("0" + value?.getDate()).slice(-2)
                        }`
                      : "",
                  },
                })
              }
            />
          </FormControl>
          <FormControl fullWidth sx={{ pt: 1 }}>
            <SelectableSearch
              isOptionEqualToValue={(option, value) =>
                +option.planid === +value.planid
              }
              filterOptions="planid"
              keys={["planid", "planname"]}
              label="Plans"
              required
              value={enableData?.planid}
              loading={() =>
                setplansData({ load: false, values: plansdata || [] })
              }
              fieldLabel="planname"
              variant={"contained"}
              name="planid"
              size="small"
              data={plansData}
              onChangeEvent={handleEnableChange}
              renderOption={(props, option) => (
                <Box
                  component="li"
                  sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                  {...props}
                >
                  {option.planname} - &#8377; {option.plancost}
                </Box>
              )}
            />
          </FormControl>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: -2,
            }}
          >
            <Button
              disabled={Object.values(enableData)?.includes("")}
              onClick={handleEnableWorkspace}
              variant="contained"
              className="mpl-primary-btn"
              sx={{ marginTop: "1.75rem", marginRight: "1rem" }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Popup>
    </>
  );
};

export default ExpiryWorkspace;
